module.exports = __webpack_public_path__ + "static/media/BO.197a9d20.svg";